/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <Header></Header>
  <LayoutPrincipal>
    <div class="account-dashboard-container">
      <div class="main-card-wrapper">
        <div class="top-card-section">
          <div class="user-profile-section">
            <div class="profile-photo-upload">
              <div class="contenedorIconoUsuario ocultar-movil">
                <img class="imagenUsuario" src="../assets/svg/icono-usuario.svg" alt="" />
              </div>
              <div class="photo-info">
                <span>{{ usuario.nombre || 'Cargando' }} {{ usuario.apellido_paterno || '' }} {{
                  usuario.apellido_materno
                }}</span>
                <span>{{ usuario.correo || 'No disponible' }}</span>
              </div>
            </div>
          </div>

          <div class="tabs-navigation">
            <button :class="{ 'tab-button': true, 'active': currentView === 'Configuracion' }"
              @click="currentView = 'Configuracion'">
              Mi cuenta
            </button>
            <button :class="{ 'tab-button': true, 'active': currentView === 'Membresia' }"
              @click="currentView = 'Membresia'">
              Membresía
            </button>
            <button :class="{ 'tab-button': true, 'active': currentView === 'Seguridad' }"
              @click="currentView = 'Seguridad'">
              Seguridad y Soporte
            </button>
          </div>
        </div>

        <div class="dynamic-view-content">
          <component :is="currentView" :usuario="usuario" :rolOpciones="rolOpciones" :FormatoRol="FormatoRol"
            :membresia="membresia" @iniciar-pago-stripe="iniciarPagoStripe" @gestionar-membresia="gestionarMembresia"
            :notificacion="notificacion" @eliminar-notificacion="eliminarNotificacion" :mensajes="mensajes"
            :nuevoMensaje="nuevoMensaje" @update:nuevoMensaje="nuevoMensaje = $event" :estadoChat="estadoChat"
            @enviar-mensaje="enviarMensaje" @finalizar-chat="finalizarChat" @reabrir-chat="reabrirChat" />
        </div>
      </div>
    </div>
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from '@/layouts/layoutPrincipal.vue';
import Header from '../layouts/Header.vue';
import Button from '@/components/Forms/Button.vue';
import Configuracion from '@/components/Perfil/Configuracion.vue';
import Membresia from '@/components/Perfil/Membresia.vue';
import Notificaciones from '@/components/Perfil/Notificaciones.vue';
import Seguridad from '@/components/Perfil/Seguridad.vue';

import userService from '@/services/userService.js'; 

export default {
  components: {
    Header,
    LayoutPrincipal,
    Button,
    Configuracion,
    Membresia,
    Notificaciones,
    Seguridad,
  },
  data() {
    return {
      currentView: 'Configuracion',
      notificacion: [],
      usuario: {
        id: null,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        correo: '',
        rol: ''
      },
      mensajes: [
        { texto: 'Hola, ¿en qué podemos ayudarte?', remitente: 'soporte' }
      ],
      nuevoMensaje: '',
      estadoChat: 'abierto',
      rolOpciones: {
        Administrador: 'Administrador',
        ROLE_KIOSKO: 'Kiosko',
        ROLE_USER: 'Usuario',
        ROLE_JEFE: 'Jefe',
        ROLE_DESARROLLADOR: 'Desarrollador',
        ROLE_TESTER: 'Tester',
        ROLE_RESIDENTE: 'Residente'
      },
      membresia: {
        activa: false,
        plan: 'Básico',
        vencimiento: 'N/A',
        detalle: ''
      }
    };
  },
  methods: {
    FormatoRol(rol) { return this.rolOpciones[rol] || rol; },

    async cargarDatosUsuario() {
      try {
        const localString = localStorage.getItem('userData');
        if (!localString) return;

        let userData = JSON.parse(localString);
        const userId = userData.id_usuario;

        if (userId) {
            try {
                const response = await userService.getUserByID(userId);
                if(response.data) {
                    userData = response.data;
                    localStorage.setItem('userData', JSON.stringify(userData));
                }
            } catch (apiError) {
                console.warn("⚠️ Usando datos locales:", apiError);
            }
        }

        this.usuario = {
          id: userData.id_usuario,
          nombre: userData.nombre,
          apellido_paterno: userData.ape_pat,
          apellido_materno: userData.ape_mat,
          correo: userData.correo,
          rol: userData.rol?.nombre || userData.rol || '',
          id_rol: userData.rol?.id_rol || userData.id_rol || null,
          telefono: userData.telefono,
          domicilio: userData.domicilio,
          estado: userData.estado,
          ciudad: userData.ciudad,
          pais: userData.pais || 'México'
        };

        const status = userData.suscripcion?.status || userData.suscripcion_status;
        const fechaFin = userData.suscripcion?.fecha_fin_periodo || userData.suscripcion_fin;
        const esActiva = ['active', 'trialing'].includes(status);

        this.membresia = {
          activa: esActiva,
          plan: esActiva ? 'Plan Instalador PRO' : 'Gratuito / Inactivo',
          detalle: status === 'trialing' ? 'Periodo de Prueba (Mes Gratis)' : 'Suscripción Activa',
          vencimiento: fechaFin 
            ? new Date(fechaFin).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
            : 'Sin vigencia',
          stripe_id: userData.suscripcion?.stripe_customer_id || null
        };

      } catch (error) {
        console.error("Error crítico:", error);
      }
    },

    eliminarNotificacion(index) {
      this.notificacion.splice(index, 1);
      localStorage.setItem("notificaciones", JSON.stringify(this.notificacion));
      window.dispatchEvent(new Event('storage'));
    },
    iniciarPagoStripe() { console.log("Iniciando pago..."); },
    gestionarMembresia(accion) {
      if (accion === 'cancelado_exito') {
        this.cargarDatosUsuario();
      }
    },
    enviarMensaje() {
      if (!this.nuevoMensaje.trim() || this.estadoChat === 'cerrado') return;
      this.mensajes.push({ texto: this.nuevoMensaje.trim(), remitente: 'usuario' });
      this.nuevoMensaje = '';
    },
    finalizarChat() { if (confirm('¿Seguro que deseas finalizar el chat?')) this.estadoChat = 'cerrado'; },
    reabrirChat() { this.estadoChat = 'abierto'; },

    handleStorageChange() {
      this.cargarNotificaciones();
      this.cargarChat();
      this.cargarDatosUsuario();
    },
    cargarNotificaciones() {
      const notis = JSON.parse(localStorage.getItem("notificaciones")) || [];
      this.notificacion = notis;
    },
    cargarChat() {
      const data = localStorage.getItem("chats_soporte");
      const chats = data ? JSON.parse(data) : {};
      const chatUsuario = chats[this.usuario.id];

      if (chatUsuario) {
        this.mensajes = chatUsuario.mensajes || [];
        this.estadoChat = chatUsuario.estado || 'abierto';
      } else {
        this.mensajes = [{ texto: 'Hola, ¿en qué podemos ayudarte?', remitente: 'soporte' }];
        this.estadoChat = 'abierto';
      }
    }
  },
  mounted() {
    this.cargarDatosUsuario();
    this.cargarNotificaciones();
    this.cargarChat();
    window.addEventListener("storage", this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.handleStorageChange);
  }
};
</script>

<style scoped>
.account-dashboard-container {
  font-family: 'Arial', sans-serif;
}

.main-card-wrapper {
  background-color: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.top-card-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.user-profile-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.profile-photo-upload {
  display: flex;
  align-items: center;
  gap: 15px;
}

.photo-info {
  display: flex;
  flex-direction: column;
  font-size: 17px;
}

.photo-info span:first-child {
  font-weight: bold;
  color: #333;
}

.tabs-navigation {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none; 
  padding-bottom: 2px;
}

.tabs-navigation::-webkit-scrollbar {
  display: none;
}

.tab-button {
  background: none;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 16px;
  color: #888;
  font-weight: 600;
  white-space: nowrap;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.tab-button:hover {
  color: #2a428c;
}

.tab-button.active {
  color: #2a428c;
  border-bottom: 3px solid #2a428c;
}

.contenedorIconoUsuario {
  width: 60px;
  height: 60px;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
}

.imagenUsuario {
  width: 27px;
  height: 32px;
}

@media (min-width: 768px) {
  .top-card-section {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
}

@media (max-width: 767px) {
  .main-card-wrapper {
    padding: 15px;
  }

  .user-profile-section {
    justify-content: center;
  }

  .profile-photo-upload {
    flex-direction: column;
    text-align: center;
  }

  .tabs-navigation {
    margin: 0 -15px;
    padding: 5px 15px;
    gap: 8px;
  }

  .tab-button {
    font-size: 14px;
    padding: 8px 16px;
    background-color: #f5f5f5; 
    border-radius: 20px; 
    border-bottom: none; 
  }

  .tab-button.active {
    background-color: #29b9f6; 
    color: white;
    border-bottom: none;
    box-shadow: 0 2px 8px rgba(152, 77, 33, 0.3);
  }
}
</style>